import { render, staticRenderFns } from "./VNavTabs.vue?vue&type=template&id=5d22e1a2&lang=pug&"
import script from "./VNavTabs.vue?vue&type=script&lang=js&"
export * from "./VNavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports